'use client'

import { useEffect } from 'react'

export type ErrorPageProps = {
  error: Error & { digest?: string }
  reset: () => void
  title?: string
  message?: string
  buttonText?: string
}

export function ErrorPage({
  error,
  reset,
  title = 'Something went wrong!',
  message,
  buttonText = 'Try again',
}: ErrorPageProps) {
  useEffect(() => {
    console.error('Error boundary caught:', error)
  }, [error])

  return (
    <div className="flex flex-col items-center justify-center min-h-screen bg-background-default">
      <h1 className="text-4xl font-bold mb-4 text-foreground-default">{title}</h1>
      <p className="mb-8 text-foreground-muted">{message || (error instanceof Error ? error.message : String(error)) || 'An unexpected error occurred.'}</p>
      <button
        onClick={() => reset()}
        className="px-4 py-2 rounded transition-colors bg-primary text-primary-foreground hover:bg-primary-hover"
      >
        {buttonText}
      </button>
    </div>
  )
}

